import { render, staticRenderFns } from "./BrandCaprimo.vue?vue&type=template&id=822af366&scoped=true&"
import script from "./BrandCaprimo.vue?vue&type=script&lang=js&"
export * from "./BrandCaprimo.vue?vue&type=script&lang=js&"
import style0 from "./BrandCaprimo.vue?vue&type=style&index=0&id=822af366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822af366",
  null
  
)

export default component.exports